import GaliPlayerBadge from './GaliPlayerBadge';
import { playerName } from '../utils/galiDisplay';
import { playerRefKey } from '../utils/galiPlayerRefs';

const GaliTeamCard = ({ title, name, players = [], captainRef, onCaptain, onRemove, editableName, onNameChange }) => {
  const captainKey = playerRefKey(captainRef);
  return (
    <section className="gali-card">
      <div className="d-flex justify-content-between align-items-center gap-2 mb-2">
        <h2 className="h5 mb-0">{title}</h2>
        <span className="badge text-bg-light">{players.length} players</span>
      </div>
      {editableName ? <input className="form-control mb-3" value={name || ''} onChange={(event) => onNameChange?.(event.target.value)} aria-label={`${title} name`} /> : <p className="fw-semibold mb-3">{name}</p>}
      <div className="gali-player-list">
        {players.length ? players.map((player) => {
          const key = playerRefKey(player.ref || player);
          return (
            <div className="gali-player-row" key={key}>
              <span>{playerName(player)}{key === captainKey ? <GaliPlayerBadge type="captain" /> : null}</span>
              <span className="gali-actions">
                {onCaptain ? <button className="btn btn-sm btn-outline-primary" type="button" onClick={() => onCaptain(player)}>Captain</button> : null}
                {onRemove ? <button className="btn btn-sm btn-outline-danger" type="button" onClick={() => onRemove(player)}>Remove</button> : null}
              </span>
            </div>
          );
        }) : <div className="alert alert-light border mb-0">No players yet.</div>}
      </div>
    </section>
  );
};
export default GaliTeamCard;
